export const LOG_IN = "LOG_IN"
export const LOGGED_IN = "LOGGED_IN"
export const LOG_OUT = "LOG_OUT"
export const LOGIN_ERROR = "LOGIN_ERROR"

/** BREADCRUMBS */
export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
export const APPEND_BREADCRUMB = "APPEND_BREADCRUMB";
export const CLEAN_BREADCRUMBS = "CLEAN_BREADCRUMBS";

/** SESSION */
export const FETCH_SESSION = "FECTH_SESSION";
export const FETCH_SESSION_FULFILLED = "FECTH_SESSION_FULFILLED";
export const FETCH_SESSION_PENDING = "FECTH_SESSION_PENDING";
export const FECTH_SESSION_REJECTED = "FECTH_SESSION_REJECTED";

/** SESSION */
export const FETCH_SESSION_BY_DATE = "FETCH_SESSION_BY_DATE";
export const FETCH_SESSION_BY_DATE_FULFILLED = "FETCH_SESSION_BY_DATE_FULFILLED";
export const FETCH_SESSION_BY_DATE_PENDING = "FETCH_SESSION_BY_DATE_PENDING";
export const FETCH_SESSION_BY_DATE_REJECTED = "FETCH_SESSION_BY_DATE_REJECTED";
export const FETCH_SESSION_BY_PROPOSAL = "FETCH_SESSION_BY_PROPOSAL";
export const FETCH_SESSION_BY_PROPOSAL_PENDING = "FETCH_SESSION_BY_PROPOSAL_PENDING";
export const FETCH_SESSION_BY_PROPOSAL_FULFILLED = "FETCH_SESSION_BY_PROPOSAL_FULFILLED";
export const FETCH_SESSION_BY_PROPOSAL_REJECTED = "FETCH_SESSION_BY_PROPOSAL_REJECTED";

/** SITES */
export const SITE_SELECTED = "SITE_SELECTED";

/** PROPOSAL */
export const FETCH_PROPOSAL = "FETCH_PROPOSAL";
export const FETCH_PROPOSAL_FULFILLED = "FETCH_PROPOSAL_FULFILLED";
export const FETCH_PROPOSAL_PENDING = "FETCH_PROPOSAL_PENDING";
export const FETCH_PROPOSAL_REJECTED = "FETCH_PROPOSAL_REJECTED";



/** CONFIGURATION */
export const LOAD_CONFIGURATION = "LOAD_CONFIGURATION";


/** JOBS */
export const FETCH_DATACOLLECTIONS_JOB_TYPES = "FETCH_DATACOLLECTIONS_JOB_TYPES";
export const FETCH_DATACOLLECTIONS_JOB_TYPES_FULFILLED = "FETCH_DATACOLLECTIONS_JOB_TYPES_FULFILLED";
export const FETCH_DATACOLLECTION_JOB_TYPES = "FETCH_DATACOLLECTION_JOB_TYPES";
export const FETCH_DATACOLLECTION_JOB_TYPES_FULFILLED = "FETCH_DATACOLLECTION_JOB_TYPES_FULFILLED";
export const FETCH_DATACOLLECTIONGROUP_JOB_TYPES = "FETCH_DATACOLLECTIONGROUP_JOB_TYPES";
export const FETCH_DATACOLLECTIONGROUP_JOB_TYPES_FULFILLED = "FETCH_DATACOLLECTIONGROUP_JOB_TYPES_FULFILLED";
export const FETCH_AUTOPROCINTEGRATION_JOB_TYPES = "FETCH_AUTOPROCINTEGRATION_JOB_TYPES";
export const FETCH_AUTOPROCINTEGRATION_JOB_TYPES_FULFILLED = "FETCH_AUTOPROCINTEGRATION_JOB_TYPES_FULFILLED";


export const FETCH_JOBS = "FETCH_JOBS";
export const FETCH_JOBS_PENDING = "FETCH_JOBS_PENDING";
export const FETCH_JOBS_FULFILLED = "FETCH_JOBS_FULFILLED";


/** APPLICATION */
export const APPLICATION_SET_ACTIVE_PROPOSAL = "APPLICATION_SET_ACTIVE_PROPOSAL";
export const APPLICATION_SET_ACTIVE_SESSION = "APPLICATION_SET_ACTIVE_SESSION";
export const APPLICATION_SELECT_DATACOLLECTIONGROUP = "APPLICATION_SELECT_DATACOLLECTIONGROUP";
export const APPLICATION_UNSELECT_DATACOLLECTIONGROUP = "APPLICATION_UNSELECT_DATACOLLECTIONGROUP";
export const APPLICATION_SELECT_DATACOLLECTION = "APPLICATION_SELECT_DATACOLLECTION";
export const APPLICATION_UNSELECT_DATACOLLECTION = "APPLICATION_UNSELECT_DATACOLLECTION";
export const APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP = "APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP";
export const APPLICATION_ADD_PROCESS_DATACOLLECTION = "APPLICATION_ADD_PROCESS_DATACOLLECTION";
export const APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION = "APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION";



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js